import type { SupportTicket } from '../types'

import { useState } from 'react'

import { useCloseModal, useConfigureModalController, useModalController } from '@/atoms'

type ModalState = 'ready' | 'submitting' | 'error'

interface ModalData {
  ticket: SupportTicket
}

export const modalId = 'supportTicket'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export const useConfigureController = (ticket: SupportTicket) => {
  const close = useCloseModal()

  // INITIALIZATION
  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        ticket: {
          topic: ticket.topic || '',
          message: ticket.message || '',
          successMessage: ticket.successMessage || '',
        },
      },
    }),
  }))

  const ctrl = useConfigureModalController<ModalData, ModalState>(modalId, options)

  return ctrl
}
